/* hs-eslint ignored failing-rules */
/* eslint-disable @typescript-eslint/no-floating-promises */

import FormattedMessage from 'I18n/components/FormattedMessage';
import { useEffect } from 'react';
import { H7 } from 'UIComponents/elements/headings';
import UITag from 'UIComponents/tag/UITag';
import { useTracker } from '../../../context/hooks';
import { removeAttachedContent } from '../data/attachedContent/thunks';
import { fetchTopics } from '../data/topics/thunks';
import { useDispatch } from '../store';
import { ThingsPeopleCover } from './ThingsPeopleCover';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const AttachedState = ({
  attachedCluster
}) => {
  const dispatch = useDispatch();
  const {
    track
  } = useTracker();
  const {
    attachedContentId,
    clusterPhrase,
    subtopicPhrase,
    clusterId
  } = attachedCluster;
  useEffect(() => {
    dispatch(fetchTopics({
      clusterId
    }));
  }, [clusterId, dispatch]);
  const handleCloseClick = () => {
    track('clickedDetachTopic');
    if (attachedContentId) {
      dispatch(removeAttachedContent({
        attachedContentId
      }));
    }
  };
  return /*#__PURE__*/_jsxs("section", {
    "data-test-id": "topic-editor-attached-state",
    className: "m-all-6",
    children: [/*#__PURE__*/_jsx(H7, {
      className: "m-y-2",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "xray-recommendation-lib.seo.topicEditor.attachedState.topicLabel"
      })
    }), /*#__PURE__*/_jsx(UITag, {
      closeable: true,
      onCloseClick: handleCloseClick,
      use: "default",
      children: clusterPhrase
    }), subtopicPhrase && /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx(H7, {
        className: "m-y-2",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "xray-recommendation-lib.seo.topicEditor.attachedState.subtopicLabel"
        })
      }), /*#__PURE__*/_jsx(UITag, {
        closeable: true,
        onCloseClick: handleCloseClick,
        use: "default",
        children: subtopicPhrase
      })]
    }), /*#__PURE__*/_jsx(ThingsPeopleCover, {
      phrase: subtopicPhrase || clusterPhrase
    })]
  });
};